import React, {useState, useEffect} from "react";
// @ts-ignore
import {FaHtml5, FaCss3, FaJs, FaReact, FaNodeJs, FaPython, FaJava} from "react-icons/fa";

const skills = [
  { icon: <FaHtml5 />, name: "HTML5", color: "#E34C26" },
  { icon: <FaCss3 />, name: "CSS3", color: "#1572B6" },
  { icon: <FaJs />, name: "JavaScript", color: "#F7DF1E" },
  { icon: <FaReact />, name: "React", color: "#61DBFB" },
  { icon: <FaNodeJs />, name: "Node.js", color: "#339933" },
  { icon: <FaPython />, name: "Python", color: "#3776AB" },
  {icon: <FaJava />, name: "Java", color: "#1565C0"}
];

const SkillsList = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % skills.length);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const renderSkills = () => {
    const items = [];
    for (let i = 0; i < skills.length; i++) {
      const index = (currentIndex + i) % skills.length;
      const { icon, name, color } = skills[index];
      items.push(
        <div key={name} style={{ marginRight: 10 }}>
          {React.cloneElement(icon, { style: { color, fontSize:30 } })}
        </div>
      );
    }
    return items;
  };

  return (
    <div style={{display: "flex", overflowX: "hidden"}}>
      {renderSkills()}
    </div>
  );
};

export default SkillsList;
